import React, {FC, useRef} from "react"
import Button from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"
import ZipModal from "@irati-web/payments/src/components/ZipModal"

const ZipReadMoreAndModal: FC = () => {
  const readMoreModal = useRef(null)
  const handleReadMore = () => readMoreModal.current.show()

  return (
    <div>
      <Button cta small onClick={handleReadMore}>
        <FormattedMessage id="platform.payments.zip.readMore" />
      </Button>
      <ZipModal ref={readMoreModal} />
    </div>
  )
}

export default ZipReadMoreAndModal
